<template>
    <div>
        <div class="tab-complete" v-if="unFinishedField === 0">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <span class="tab-count" v-else>{{unFinishedField}}</span>
    </div>
</template>
<script>
export default {
    props: ["unFinishedField"]
}
</script>